module.exports = __webpack_public_path__ + "img/icn_phone.b6290fac.svg";